"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorGroup = void 0;
exports.colorGroup = [
    {
        id: 1,
        name: 'Black',
        color_name: 'Black',
        color_group: 'Black',
        hex: '000000',
        regex: /black|charcoal/i
    },
    {
        id: 2,
        name: 'Blue',
        color_name: 'Blue',
        color_group: 'Blue',
        hex: '0000ff',
        regex: /blue/i
    },
    {
        id: 3,
        name: 'Brown & Beige',
        color_name: 'Brown & Beige',
        color_group: 'Brown & Beige',
        hex: 'cdaa7d',
        regex: /brown|beige|champagne|tan/i
    },
    {
        id: 4,
        name: 'Gray',
        color_name: 'Gray',
        color_group: 'Gray',
        hex: 'c0c0c0',
        regex: /gray|titanium|pewter/i
    },
    {
        id: 5,
        name: 'Gold & Cream',
        color_name: 'Gold & Cream',
        color_group: 'Gold & Cream',
        hex: 'D4AF37',
        regex: /gold|cream/i
    },
    {
        id: 6,
        name: 'Green',
        color_name: 'Green',
        color_group: 'Green',
        hex: '008000',
        regex: /green|teal|turquoise/i
    },
    {
        id: 7,
        name: 'Pink & Purple',
        color_name: 'Pink & Purple',
        color_group: 'Pink & Purple',
        hex: 'ffc0cb',
        regex: /purple|pink/i
    },
    {
        id: 8,
        name: 'Red & Orange',
        color_name: 'Red & Orange',
        color_group: 'Red & Orange',
        hex: 'ff0000',
        regex: /red|maroon|burgundy|orange/i
    },
    {
        id: 9,
        name: 'Silver',
        color_name: 'Silver',
        color_group: 'Silver',
        hex: 'e6e8fa',
        regex: /silver/i
    },
    {
        id: 10,
        name: 'White',
        color_name: 'White',
        color_group: 'White',
        hex: 'ffffff',
        regex: /white/i
    },
    {
        id: 11,
        name: 'Yellow',
        color_name: 'Yellow',
        color_group: 'Yellow',
        hex: 'ffd700',
        regex: /yellow/i
    }
];
